import React, {useState} from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography
} from '@mui/material';
import {useNavigate} from 'react-router-dom';


const programOptions = ['REACH', 'KCC', 'MSSP', 'PC FLEX'];
const msspTrackOptions = ['Track A', 'Track B', 'Track C', 'Track D', 'Track E', 'Enhanced',];

function Page1({ formData, setFormData }) {
  const navigate = useNavigate();
  const [localData, setLocalData] = useState(formData);

  // Handle change for the form fields, radio buttons, and checkboxes
  const handleChange = (e) => {
    const {name, value} = e.target;
    setLocalData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //Handle multi-select for py2025Programs
  const handleProgramChange = (e) => {
    const {value} = e.target;
    setLocalData((prev) => ({
      ...prev,
      py2025Programs: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  //Handle multi-select for msspTracks
  const handleMSSPTracksChange = (e) => {
    const {value} = e.target;
    setLocalData((prev) => ({
      ...prev,
      msspTracks: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  //  On Submit, update global state and navigate to the next page
  const handleSubmit = () => {
    // Update global state
    setFormData(localData);
    navigate('/page2');
  };

  // Check if collateral is yes or no
  const showCollateralAmount = localData.hasCollateral === 'Yes';

  // Check if py2025Programs is MSSP
  const showMSSPTracks = localData.py2025Programs.includes('MSSP');

  return (
      <Box sx={{margin: 2}}>
        <Paper sx={{padding: 2, maxWidth: 600, margin: '0 auto'}}>
          <Typography variant="h5" gutterBottom>
            Please enter your details:
          </Typography>

          {/* Company Name */}
          <TextField
              label="What Company are you representing?"
              variant="outlined"
              fullWidth
              margin="normal"
              name="companyName"
              value={localData.companyName || ''}
              onChange={handleChange}
              inputProps={{required: true}}
              error={!localData.companyName && localData.companyName !== undefined}
              helperText={!localData.companyName && localData.companyName !== undefined ? "This field is required" : ""}
          />


          {/* Email */}
          <TextField
              label="What is your email?"
              variant="outlined"
              fullWidth
              margin="normal"
              name="email"
              type="email"
              value={localData.email || ''}
              onChange={handleChange}
              inputProps={{required: true}}
              error={!localData.email?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) && localData.email !== undefined}
              helperText={!localData.email?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) && localData.email !== undefined ? "Please enter a valid email address" : ""}
          />

          {/* Name */}
            <TextField
                label="What is your name?"
                variant="outlined"
                fullWidth
                margin="normal"
                name="Name"
                value={localData.Name || ''}
                onChange={handleChange}
                />

          {/* Designation */}
            <TextField
                label="What is your designation?"
                variant="outlined"
                fullWidth
                margin="normal"
                name="designation"
                value={localData.designation || ''}
                onChange={handleChange}/>


          {/* 1) Annual Financial Guarantee */}
          <TextField
              label="What is your annual premium on Financial Guarantee(s) for your downside risk programs?"
              variant="outlined"
              fullWidth
              margin="normal"
              type="text"
              name="annualFinancialGuarantee"
              value={
                localData.annualFinancialGuarantee ?
                    parseFloat(localData.annualFinancialGuarantee).toLocaleString('en-US') :
                    ''
              }
              onChange={(e) => {
                const value = e.target.value.replace(/,/g, '');
                if (!isNaN(value)) {
                  handleChange({target: {name: "annualFinancialGuarantee", value}});
                }
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
          />

          {/* 2) Collateral */}
          <FormControl sx={{mt: 2}}>
            <FormLabel>
              Do you have to collateralize your Financial Guarantee(s)?
            </FormLabel>
            <RadioGroup
                row
                name='hasCollateral'
                value={localData.hasCollateral}
                onChange={handleChange}
            >
              <FormControlLabel value="Yes" control={<Radio/>} label="Yes"/>
              <FormControlLabel value="No" control={<Radio/>} label="No"/>
            </RadioGroup>
          </FormControl>

          {/* If yes, show Collateral Amount */}
          {showCollateralAmount && (
              <TextField
                  label="What is the amount of the collateral that your bank or surety provider holds?"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  type="text"
                  name="collateralAmount"
                  value={
                    localData.collateralAmount
                        ? parseFloat(localData.collateralAmount).toLocaleString('en-US')
                        : ''
                  }
                  onChange={(e) => {
                    const value = e.target.value.replace(/,/g, '');
                    if (!isNaN(value)) {
                      handleChange({target: {name: "collateralAmount", value}});
                    }
                  }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
              />
          )}

          {/* 3) Stop Loss Spend */}
          <TextField
              label="What is your annual premium on stop-loss insurance?"
              variant="outlined"
              fullWidth
              margin="normal"
              type="text"
              name="stopLossSpend"
              value={
                localData.stopLossSpend ?
                    parseFloat(localData.stopLossSpend).toLocaleString('en-US') :
                    ''
              }
              onChange={(e) => {
                const value = e.target.value.replace(/,/g, '');
                if (!isNaN(value)) {
                  handleChange({target: {name: "stopLossSpend", value}});
                }
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
          />


          {/* 4) Actuarial Spend */}
          <TextField
              label="What is your annual spend on 3rd party actuarial consulting?"
              variant="outlined"
              fullWidth
              margin="normal"
              type="text"
              name="actuarialSpend"
              value={
                localData.actuarialSpend
                    ? parseFloat(localData.actuarialSpend).toLocaleString('en-US')
                    : ''
              }
              onChange={(e) => {
                const value = e.target.value.replace(/,/g, '');
                if (!isNaN(value)) {
                  handleChange({target: {name: "actuarialSpend", value}});
                }
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
          />

          {/* 5) PY2025 Programs (multi-select)*/}
          <FormControl fullWidth sx={{mt: 2}}>
            <InputLabel id="programs-label">For Performance Year 2025, what programs will you participate
              in?</InputLabel>
            <Select
                labelId="programs-label"
                multiple
                name="py2025Programs"
                value={localData.py2025Programs}
                onChange={handleProgramChange}
                renderValue={(selected) => selected.join(', ')}
            >
              {programOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    <Checkbox checked={localData.py2025Programs.indexOf(option) > -1}/>
                    <ListItemText primary={option}/>
                  </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* 6) MSSP Tracks (multi-select) */}
          {showMSSPTracks && (
              <FormControl fullWidth sx={{mt: 2}}>
                <InputLabel id="msspTracks-label">For MSSP, what tracks will you participate in?</InputLabel>
                <Select
                    labelId="msspTracks-label"
                    multiple
                    name="msspTracks"
                    value={localData.msspTracks}
                    onChange={handleMSSPTracksChange}
                    renderValue={(selected) => selected.join(', ')}
                >
                  {msspTrackOptions.map((track) => (
                      <MenuItem key={track} value={track}>
                        <Checkbox checked={localData.msspTracks.indexOf(track) > -1}/>
                        <ListItemText primary={track}/>
                      </MenuItem>
                  ))}
                </Select>
              </FormControl>
          )}

          {/* Submit Button */}
          <Button
              variant="contained"
              color="primary"
              sx={{mt: 3}}
              onClick={() => {
                if (!localData.companyName || !localData.email) {
                  alert("Please fill in the Company Name and Email before proceeding.");
                  return;
                }
                handleSubmit();
              }}
          >
            Submit
          </Button>
        </Paper>
      </Box>
  );
}
export default Page1;